import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { Box, Text } from '../design/css';
import { DateWrapper, InputWrapper } from './css';
import DateFiltersButtons from './dateFiltersButtons';

const DateFilters = ({ filterState, updateFilters, filterLabels }) => (
  <Box display="flex" width={30} mdWidth={100}>
    <Box>
      <Box>
        <Text>{filterLabels.date}</Text>
      </Box>
      <DateFiltersButtons
        filterCriteria={filterState.filterCriteria}
        updateFilters={updateFilters}
        filterLabels={filterLabels}
      />
      <InputWrapper>
        <DateWrapper width="162px" mr={16}>
          <DatePicker
            dateFormat="yyyy/MM/dd"
            placeholderText={filterLabels.startDate}
            selected={filterState.startDate}
            onChange={value => updateFilters('startDate', value)}
          />
        </DateWrapper>
        <DateWrapper width="186px">
          <DatePicker
            dateFormat="yyyy/MM/dd"
            placeholderText={filterLabels.endDate}
            minDate={filterState.startDate}
            selected={filterState.endDate}
            onChange={value => updateFilters('endDate', value)}
          />
        </DateWrapper>
      </InputWrapper>
    </Box>
  </Box>
);

DateFilters.propTypes = {
  filterState: PropTypes.objectOf(PropTypes.any).isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterLabels: PropTypes.shape({
    date: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    openedDate: PropTypes.string,
    completedDate: PropTypes.string
  }).isRequired
};

export default DateFilters;
